import { render, staticRenderFns } from "./servico.geral.vue?vue&type=template&id=00bb3e10&"
import script from "./servico.geral.vue?vue&type=script&lang=js&"
export * from "./servico.geral.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports